namespace Solovis.UI.Dialogs {

    export interface JsonDialogOptions {
        json: string;
        applyCallback: (newJson) => void;
        cancelCallback?: () => void;
        canEdit?: boolean;
        autoIndentSpaces?: number;

        title?: string;
        mode?: "json" | "javascript";
    }

    export class JsonDialog {

        private _options: JsonDialogOptions;
        private _json: string;
        private _applyCallback: (newJson) => any;
        private _cancelCallback: () => any;

        private _dialog: Solovis.UI.Dialog;
        private _jsonTextArea: any;
        private _editor: any;
        private _canEdit: boolean;
        private _autoIndentSpaces: number;

        constructor(options: JsonDialogOptions) {
            this._options = options;
            this._json = options.json;
            this._applyCallback = options.applyCallback;
            this._cancelCallback = options.cancelCallback;
            this._canEdit = Solovis.isNotNull(options.canEdit) ? options.canEdit : false;
            this._autoIndentSpaces = Solovis.isNotNull(options.autoIndentSpaces) ? options.autoIndentSpaces : null;

            if (this._autoIndentSpaces !== null && this._json) {
                try {
                    let jsonObj = JSON.parse(this._json);
                    this._json = JSON.stringify(jsonObj, null, this._autoIndentSpaces);
                }
                catch (ex) {
                    // Invalid JSON, so just leave in unformatted form.
                }
            }
        }

        public show() {
            let self = this;
            Solovis.ModuleLoader.modalEnsureModuleListLoaded(["codemirror"], function () {
                self.internalShow();
            });
        }

        private internalShow() {
            if (this._dialog) {
                return;
            }

            let self = this;

            let applied = false;

            var formDiv = $("<div>");           

            this._jsonTextArea = $("<textarea>").appendTo(formDiv);
            this._jsonTextArea.val(this._json);

            let mode = "application/json";
            if (mode == "javascript") {
                mode = "application/javascript";
            }

            this._editor = (window as any).CodeMirror.fromTextArea(this._jsonTextArea.get(0), {
                mode: mode,
                indentUnit: 4,
                lineNumbers: false,
                styleActiveLine: true,
                matchBrackets: true,
                readOnly: !this._canEdit,

                extraKeys: {
                    "Ctrl-Space": "autocomplete"
                }
            });

            this._editor.setSize("100%", "200px");

            var buttons = [];

            var closeTitle = "Close";

            if (this._canEdit) {
                buttons.push({
                    label: "Apply",
                    click: function () {
                        applied = true;
                        let newJson = self._editor.getValue();
                        try {
                            JSON.parse(newJson);
                        }
                        catch (ex) {
                            Solovis.UI.alert("Invalid json entered.");
                            return;
                        }

                        let applyResult = self._applyCallback(newJson);
                        if (Solovis.isNull(applyResult) || applyResult === true) {
                            self._dialog.close();
                        }
                        else {
                            if (applyResult.then) {
                                // A promise was returned, so we don't want to apply same conditions to closing.
                                applyResult.then(function (applyResultResult) {
                                    if (Solovis.isNull(applyResultResult) || applyResultResult === true) {
                                        self._dialog.close();
                                    }
                                });
                            }
                        }
                    }
                });

                closeTitle = "Cancel";
            }

            buttons.push({
                label: closeTitle,
                click: function () {
                    self._dialog.close();
                }
            });


            var desiredWidth = Math.min($(window).width() * .8, 700);
            var desiredHeight = Math.min($(window).height() * .8, 600);

            let title = "JSON";
            if (this._options.title) {
                title = this._options.title;
            }

            this._dialog = new Solovis.UI.Dialog({
                container: formDiv,
                title: title,

                autoOpen: true,
                width: desiredWidth,
                height: desiredHeight,
                center: true,
                modal: true,
                destroyOnClose: true,
                actions: [],

                noPaddingOnContent: true,

                buttons: buttons,

                activate: function () {
                    self._autoSizeEditor();
                },

                resize: function () {
                    self._autoSizeEditor();
                },

                deactivate: () => {
                    if (!applied && this._cancelCallback) {
                        this._cancelCallback();
                    }
                }
            });
        }

        private _autoSizeEditor() {
            var availableHeight = this._dialog.getAvailableContentHeight();            
            var newEditorHeight = availableHeight;

            this._editor.setSize("100%", "" + newEditorHeight + "px");
        }

    }

}